export default __webpack_public_path__ + "static/media/404page.87049462.jpg";